import React from 'react';
import PropTypes from 'prop-types';
import { ImageBased, Profile } from './styles';

const ImageLayout = ({ isClass, style, src, alt, isProfile }) => {
  let Image;

  if (isProfile) {
    Image = Profile;
  } else {
    Image = ImageBased;
  }

  return (
    <Image className={isClass} style={style}>
      <img src={src} alt={alt} />
    </Image>
  );
};

ImageLayout.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  isClass: PropTypes.string,
  isProfile: PropTypes.bool,
  style: PropTypes.object,
};

export default ImageLayout;
